import React, { JSX, ReactNode, useRef } from 'react';
import { FacetValue, RemoveFilterType } from 'components/types/FilterTypes';

type ViewAllPanelProps = {
  addFilter: Function;
  children?: ReactNode;
  filterCategory: string;
  filters: Array<FacetValue>;
  inputType?: string;
  isOpen?: boolean;
  placeholder?: string;
  removeFilter: RemoveFilterType;
  selectedData?: Array<string>;
  title: string;
  toggleViewAll: Function;
  updateLonLatFilter?: Function;
  noCount?: boolean;
};

const ViewAllPanel = (props: ViewAllPanelProps): JSX.Element => {
  const isOpen = props.isOpen ?? false;

  const overlayRef = useRef<HTMLDivElement>(null);

  const { children, filters, noCount } = props;

  return (
    <>
      <div
        className={isOpen ? 'view-all-panel view-all-open' : 'view-all-panel'}
        ref={overlayRef}
      >
        <div className="view-all-body">
          {children}

          <div className="view-all-no-accordion">
            {filters?.map((key: any, idx: number) => (
              <div
                key={key.id ? key.id : idx}
                className={
                  (props.inputType != undefined
                    ? props.inputType
                    : 'checkbox') + '-wrapper'
                }
              >
                <input
                  onChange={e => {
                    if (e.target.checked) {
                      props.addFilter(props.filterCategory, key.text, {
                        id: key.id,
                        text: key.text,
                        count: key.count,
                      });
                      props.updateLonLatFilter &&
                        props.updateLonLatFilter('lonlat', [key.lon, key.lat]);
                    } else {
                      props.removeFilter(props.filterCategory, key.text);
                    }
                    props.toggleViewAll();
                  }}
                  type={
                    props.inputType != undefined ? props.inputType : 'checkbox'
                  }
                  id={key.text}
                  checked={props.selectedData?.includes(key.text)}
                  name={props.filterCategory}
                />
                <label htmlFor={key.text}>
                  <span className="label-name">{key.text}</span>&nbsp;
                  {!noCount && (
                    <span className="label-number">({key.count})</span>
                  )}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewAllPanel;
